// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"371": "b965dacc","5345": "a6611889","6489": "688e6f00","7278": "6719d36f","7348": "c2bbdf9f","860": "481e96ca","8772": "d6b1daf0",}[chunkId] + ".css"
}